<template>
  <PremierInsurance :changedOrder="changedOrder" />
</template>

<script>
import PremierInsurance from "@/components/insurances/shared/PremierInsurance";
export default {
  name: "Survival",
  props: {
    changedOrder: {
      type: Boolean,
      default: false
    }
  },
  components: {PremierInsurance}
}
</script>

<style scoped>

</style>